import { Layout } from "antd";
import { useNavigate } from "react-router";

import { useAuth } from "@/entities/session";
import { LoginForm } from "@/features/admin-login";
import { ROUTES } from "@/shared/config";

export function LoginPage() {
  const { setAdmin } = useAuth();
  const navigate = useNavigate();

  return (
    <Layout
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        // Два мягких пятна вместо ровной заливки: страница входа — это один
        // прямоугольник посреди пустоты, и плоский фон делает её похожей на
        // ошибку загрузки.
        backgroundImage:
          "radial-gradient(60rem 60rem at 20% 0%, color-mix(in srgb, var(--ant-color-primary) 12%, transparent), transparent 60%), radial-gradient(50rem 50rem at 100% 100%, color-mix(in srgb, #06b6d4 12%, transparent), transparent 60%)",
      }}
    >
      <LoginForm
        onSuccess={(admin) => {
          setAdmin(admin);
          void navigate(ROUTES.dashboard, { replace: true });
        }}
      />
    </Layout>
  );
}
